// @/components/ui/Badge.tsx
import React from 'react';
import { cn } from '@/utils/utils'; // Si no tienes esta función, la definimos abajo

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning';
    icon?: React.ReactNode;
    iconPosition?: 'left' | 'right';
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
    ({ className, variant = 'default', icon, iconPosition = 'left', children, ...props }, ref) => {
        const variants = {
            default: 'bg-primary text-primary-foreground hover:bg-primary/80',
            secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/80',
            outline: 'text-foreground border border-input bg-background hover:bg-accent hover:text-accent-foreground',
            success: 'bg-green-100 text-green-800 hover:bg-green-200 dark:bg-green-900 dark:text-green-300',
            warning: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200 dark:bg-yellow-900 dark:text-yellow-300',
        };

        const iconElement = icon && (
            <span className={cn(
                'flex items-center',
                children && iconPosition === 'left' && 'mr-1',
                children && iconPosition === 'right' && 'ml-1'
            )}>
                {icon}
            </span>
        );

        return (
            <div
                ref={ref}
                className={cn(
                    'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
                    variants[variant],
                    className
                )}
                {...props}
            >
                {iconPosition === 'left' && iconElement}
                {children}
                {iconPosition === 'right' && iconElement}
            </div>
        );
    }
);
Badge.displayName = 'Badge';

export { Badge };